import { useEffect, useState } from "react";
import "./AdminNewsletters.css";
import CdnEditor from "../../app/components/CkEditorCustom/CdnEditor";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import imageCompression from "browser-image-compression";
import { blogPostStatus } from "../../app/Enums/StatusEnums";
import DOMPurify from "dompurify";
import {
  UpdateNewsletter,
  GetSngleNewsletter,
} from "../../api/newsletterApi/newsletter";
import { useSelector } from "react-redux";
import Feedback from "../../app/components/FeedbackModal/Feedback";
import { routePath } from "../../app/routes/routepath";
import uploadSvg from "../../assets/icons/upload.svg";
const EditNewsletter = () => {
  const navigate = useNavigate();
  const [finalData, setFinalData] = useState({
    newsletterTitle: "",
    newsletterDescription: "",
    newsletterContent: "",
    newsletterCoverImage: "",
  });

  const [isProcessing, setisProcessing] = useState(null);
  const [feedback, setFeedback] = useState({
    open: false,
    type: "success",
    title: "",
    message: "",
  });
  const selectedNewsletter = useSelector(
    (state) => state.selectedNewsletter.newsletter,
  );

  console.log("this id form edit page :", selectedNewsletter);

  const fetchNewsletter = async () => {
    try {
      const res = await GetSngleNewsletter(selectedNewsletter);

      const data = res?.data?.result_value;

      if (!data || res?.data?.result !== 1) {
        throw new Error("Invalid newsletter data");
      }

      setFinalData({
        newsletterId: selectedNewsletter,
        newsletterTitle: data.newsletter_title || "",
        newsletterDescription: data.newsletter_description || "",
        newsletterContent: data.newsletter_content || "",
        newsletterCoverImage: data.newsletter_coverImage || "",
      });
    } catch (error) {
      toast.error("Error fetching newsletter data");
      navigate("/adminNewsletter");
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Please login to post Newsletter");
      navigate("/home");
      return;
    }

    if (selectedNewsletter) {
      fetchNewsletter();
    } else {
      toast.error("No newsletter selected for editing");
      navigate("/adminNewsletter"); // go back safely
    }
  }, [navigate]);

  const handleResetForm = () => {
    setFinalData({
      newsletterTitle: "",
      newsletterDescription: "",
      newsletterContent: "",
      newsletterCoverImage: "",
    });
  };

  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const [submitResponse, setSubmitResponse] = useState(true);

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  const validateForm = () => {
    const {
      newsletterTitle,
      newsletterDescription,
      newsletterContent,
      newsletterCoverImage,
    } = finalData;

    if (
      !newsletterTitle?.trim() ||
      !newsletterDescription?.trim() ||
      !newsletterContent?.trim() ||
      !newsletterCoverImage
    ) {
      toast.error("Please fill all the required fields.");
      return false;
    }
    return true;
  };

  const sanitizeInputs = () => {
    const cleanHTML = DOMPurify.sanitize(finalData.newsletterContent, {
      FORBID_ATTR: ["onerror", "onload", "onclick", "onmouseover"],
      FORBID_TAGS: ["iframe", "object", "embed"],
    });

    return {
      ...finalData,
      newsletterTitle: DOMPurify.sanitize(finalData.newsletterTitle),
      newsletterDescription: DOMPurify.sanitize(
        finalData.newsletterDescription,
      ),
      newsletterContent: cleanHTML,
    };
  };

  const handleTitleChange = (e) => {
    const value = e.target.value;
    setFinalData((prev) => ({ ...prev, newsletterTitle: value }));
  };

  const handleDescriptionChange = (e) => {
    const value = e.target.value;
    setFinalData((prev) => ({ ...prev, newsletterDescription: value }));
  };

  const handleContentChange = (value) => {
    setFinalData((prev) => ({ ...prev, newsletterContent: value }));
  };

  const handleCoverImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const maxSize = 20 * 1024 * 1024;
    if (file.size > maxSize) {
      toast.error("Image size cannot exceed 20 MB");
      e.target.value = ""; // optional: clear input
      return;
    }

    /* if (file.size > 2 * 1024 * 1024) { // 2 MB limit
            toast.error("Image too large. Please upload below 2MB.");
            return;
        } */
    console.log(file.size);

    try {
      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1024,
        useWebWorker: true,
      };
      const compressedFile = await imageCompression(file, options);
      const base64 = await convertToBase64(compressedFile);
      console.log(base64);

      setFinalData((prev) => ({ ...prev, newsletterCoverImage: base64 }));
    } catch (error) {
      console.error("Compression and conversion error", error);
    }
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    const authorId = parseInt(localStorage.getItem("UserId"));
    /*         const roleId = parseInt(localStorage.getItem("RoleId")); */

    const updatedData = {
      ...sanitizeInputs(),
      actionType: blogPostStatus.submit,
      authorId,
    };

    console.log(updatedData);
    setisProcessing("Publish Newsletter");
    try {
      const res = await UpdateNewsletter(updatedData);
      console.log("API Response", res);
      console.log("Submitted data : - ", updatedData);
      if (!res.error) {
        setSubmitResponse(!res.error);
        handleResetForm();
        setIsModalOpen1(true);
        setFeedback({
          open: true,
          type: "success",
          title: "Newsletter Updated",
          message: "The newsletter has been updated successfully.",
        });
      } else {
        setSubmitResponse(false);
        setIsModalOpen1(true);
        setFeedback({
          open: true,
          type: "error",
          title: "Update Failed",
          message: "Something went wrong. Please try again.",
        });
      }
    } catch (error) {
      console.log("Post request failed", error);
      setSubmitResponse(false);
      setIsModalOpen1(true);
      setFeedback({
        open: true,
        type: "error",
        title: "Update Failed",
        message: "Something went wrong. Please try again.",
      });
    } finally {
      setisProcessing(null);
    }
  };

  const handleBack = () => navigate("/adminNewsletter");

  return (
    <>
      <div className="role-box">
        <ul className="breadcumb">
          <li className="active" onClick={handleBack}>
            <i className="bi bi-file-earmark-richtext"></i>
            Newsletter
          </li>

          <li className="dash-arrow">/</li>

          <li>
            <span>Edit Newsletter</span>
          </li>
        </ul>
      </div>
      <div className="newsletter_wrapper">
        {/* <div className="breadcrumb">
        <div className="home-icon" onClick={handleBack}>
          <i className="bi bi-card-text"></i>
        </div>
        <span>&gt;</span>
        <a className="active">Eidt Newsletter</a>
      </div> */}
        <div>
          <div className="main_widget">
            <div className="w-100 border-radius-6">
              <div className="form-header">
                <h2>Edit Newsletter</h2>
              </div>
              <div className="p-20">
                <div className="blog_form_Wraper">
                  <label>
                    Title<sup>*</sup>
                  </label>
                  {/* <div className="input_box">
              <i className="bi bi-fonts"></i>
              <input
                type="text"
                value={finalData.newsletterTitle}
                placeholder="Title"
                className="form-control"
                onChange={handleTitleChange}
              />
            </div> */}
                  <div className="input_box">
                    <div style={{ position: "relative" }}>
                      {/* <i className="bi bi-fonts"></i> */}
                      <input
                        type="text"
                        placeholder="Enter newsletter title (max 80 characters)"
                        value={finalData.newsletterTitle}
                        className="form-control"
                        maxLength={80}
                        onChange={handleTitleChange}
                        style={{ paddingRight: "55px" }}
                      />

                      <span
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          fontSize: "12px",
                          color:
                            finalData.newsletterTitle.length >= 80
                              ? "red"
                              : "#999",
                          pointerEvents: "none",
                        }}
                      >
                        {finalData.newsletterTitle.length}/80
                      </span>
                    </div>
                  </div>
                </div>
                <div className="blog_form_Wraper">
                  <label>
                    Summary<sup>*</sup>
                  </label>
                  <div className="input_box">
                    {/* <i className="bi bi-pencil"></i> */}
                    <input
                      type="text"
                      value={finalData.newsletterDescription}
                      placeholder="Keywords"
                      className="form-control"
                      onChange={handleDescriptionChange}
                    />
                  </div>
                </div>
                <div className="blog_form_Wraper">
                  <label>
                    Content<sup>*</sup>
                  </label>
                  <div className="input_box">
                    <CdnEditor
                      value={finalData.newsletterContent}
                      toolbar={[
                        "undo",
                        "redo",
                        "|",
                        "heading",
                        "|",
                        "bold",
                        "italic",
                        "link",
                        "|",
                        "bulletedList",
                        "numberedList",
                        "|",
                        "blockQuote",
                      ]}
                      onChange={handleContentChange}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="blog_form_Wraper">
                  <label>
                    Upload Cover Image<sup>*</sup>
                  </label>
                  <div className="upload-container">
                    <img src={uploadSvg} alt="Upload" />
                    <h2>Upload Your File</h2>
                    <label htmlFor="file-upload" className="custom-file-upload">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M12 16v-8M8 12l4-4 4 4M4 20h16"
                          stroke="currentColor"
                          strokeWidth="2"
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      Choose File
                    </label>
                    <p class="limit-text">Maximum upload size 20 MB</p>
                    <input
                      id="file-upload"
                      type="file"
                      onChange={handleCoverImageChange}
                    />
                    <div>
                      {finalData.newsletterCoverImage && (
                        <img
                          src={finalData.newsletterCoverImage}
                          style={{ width: 300, height: 200, borderRadius: 10 }}
                          alt="newsletter Cover"
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className="blog_form_btn_wraper">
                  <button
                    className="delete_approve_btn"
                    onClick={handleSubmit}
                    disabled={isProcessing === "Publish Newsletter"}
                  >
                    {isProcessing === "Publish Newsletter" ? (
                      <div className="Publish_spinner"></div>
                    ) : (
                      "Publish Newsletter"
                    )}
                  </button>
                  <button
                    className="delete_reject_btn"
                    onClick={handleResetForm}
                  >
                    Reset Values
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* {isModalOpen1 && (
        <div className="modal-overlay">
          <div className="succes-modal">
            <div className="success-circle">&#10004;</div>
            <h2>{submitResponse ? "Success" : "Failed"}</h2>
            <p>
              {submitResponse
                ? "Your newsletter has been submitted for review."
                : "Something went wrong. Please try again."}
            </p>
            <div className="sucess-modal-wraper">
              <button
                onClick={() => setIsModalOpen1(false)}
                className="primary_btn"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )} */}
      </div>

      <Feedback
        isOpen={feedback.open}
        type={feedback.type}
        title={feedback.title}
        message={feedback.message}
        onClose={() => {
          setFeedback({ ...feedback, open: false });
          navigate(routePath.adminNewsletter);
        }}
      />
    </>
  );
};

export default EditNewsletter;
